module.exports = __webpack_public_path__ + "img/jxpz.41b5bc66.png";